module.exports = __webpack_public_path__ + "static/media/300c-rear-wishbone.b09beb90.jpg";